import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../../components/Dashboard";
import AdminDashboard from "../../components/AdminDashboard";
import EmpDashboard from "../EmployeeDashboard/EmployeeDashboard";
import { getUserInfoFromToken } from "../../utils/authUtils";

const MainDashboard = () => {
  const [userType, setUserType] = useState(null);
  const formikRef = useRef();

  useEffect(() => {
    const { userType } = getUserInfoFromToken();
    setUserType(userType);
  }, []);

  if (userType === "Admin") {
    return <AdminDashboard />;
  }

  if (userType === "Employer") {
    return <Dashboard />;
  }

  if (userType === "Employee") {
    return <EmpDashboard />;
  }

  return <div>User type not recognized</div>;
};

export default MainDashboard;
